var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1357_1558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40L3.44 29.6807C1.69448 26.7448 0.689655 23.3186 0.689655 19.6552C0.689655 8.8 9.48966 0 20.3448 0C31.2 0 40 8.8 40 19.6552C40 30.5103 31.2 39.3103 20.3448 39.3103C17.0421 39.3103 13.9317 38.4917 11.2 37.0531L0 40Z",
    fill: "#2CB742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8849 26.1965C31.9773 24.4814 28.6304 22.52 28.6304 22.52C27.8731 22.0883 26.9593 22.04 26.5276 22.8096C26.5276 22.8096 25.44 24.1138 25.1635 24.3014C23.9 25.1572 22.7297 25.1241 21.5483 23.9427L18.8028 21.1972L16.0573 18.4517C14.8759 17.2703 14.8428 16.1 15.6987 14.8365C15.8862 14.56 17.1904 13.4724 17.1904 13.4724C17.96 13.04 17.9118 12.1269 17.48 11.3696C17.48 11.3696 15.5187 8.02274 13.8035 7.11515C13.0738 6.72895 12.178 6.86412 11.5945 7.44757L10.3821 8.65998C6.5359 12.5062 8.42969 16.8483 12.2759 20.6945L15.7911 24.2096L19.3062 27.7248C23.1525 31.571 27.4945 33.4648 31.3407 29.6186L32.5531 28.4062C33.1366 27.8214 33.2711 26.9255 32.8849 26.1965Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1357_1558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappSvgrepoCom1);
export default __webpack_public_path__ + "static/media/whatsapp-svgrepo-com 1.3027001495d5d7dd603a7a0be6895915.svg";
export { ForwardRef as ReactComponent };